// extracted by mini-css-extract-plugin
export default {"name":"report-templates_name__ko6Jf"};